// Generated by scripts/generateImages.ts — do not edit by hand.
// Regenerate with: npx nx images @sc/marketing

export interface GeneratedImageInterface {
  width: number;
  height: number;
  hash: string;
  widths: number[];
}

export const imageManifest: Record<string, GeneratedImageInterface> = {
  "hero": {
    "width": 1440,
    "height": 860,
    "hash": "a500c2a708",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "home-hero": {
    "width": 1048,
    "height": 441,
    "hash": "2a8e31f56d",
    "widths": [
      640,
      960
    ]
  },
  "security": {
    "width": 800,
    "height": 800,
    "hash": "33d36bfa21",
    "widths": [
      640
    ]
  },
  "shots/coverage-segment": {
    "width": 1440,
    "height": 860,
    "hash": "f13773f8ef",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "shots/export-integrations": {
    "width": 1440,
    "height": 860,
    "hash": "6c22326a18",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "shots/extraction-table": {
    "width": 1440,
    "height": 860,
    "hash": "437c038dfb",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "shots/multi-hosts": {
    "width": 1440,
    "height": 860,
    "hash": "8a492fa3bd",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "shots/schema-setup": {
    "width": 1440,
    "height": 860,
    "hash": "0b07bbb64d",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "shots/team-access": {
    "width": 1440,
    "height": 860,
    "hash": "08440a9681",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "solutions/category-research": {
    "width": 1600,
    "height": 900,
    "hash": "bc728a077c",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "solutions/competitor-intel": {
    "width": 1600,
    "height": 900,
    "hash": "6672920eed",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "solutions/directory-discovery": {
    "width": 1600,
    "height": 900,
    "hash": "2bdc07953d",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "solutions/prospect-capture": {
    "width": 1600,
    "height": 900,
    "hash": "4fdb81a086",
    "widths": [
      640,
      960,
      1280
    ]
  },
  "solutions/wheel-2": {
    "width": 800,
    "height": 800,
    "hash": "8707b49039",
    "widths": [
      640
    ]
  },
  "solutions/wheel": {
    "width": 800,
    "height": 800,
    "hash": "d339689ace",
    "widths": [
      640
    ]
  },
  "theme": {
    "width": 800,
    "height": 800,
    "hash": "f1e46d44ea",
    "widths": [
      640
    ]
  }
};
